import FranchiseList from "../Component/FranchiseList";
import { connect } from 'react-redux';
import {
  getFieldOffice, getFranchiseList,
  addFieldOffice, getUserList, closeFieldOffice,
  editFieldOffice, updateFieldOffice, getUserDetail, getFranchise, getGeocodeAddress, resetGeocodeAddress
} from '../../../../Action';


const mapStateToProps = (state) => {
  let { FieldOffice, FranchiseList, FranchiseAdd,
    QuickbookLogin,
    UserList, CloseFranchise, EditFieldOffice, UpdateFranchise, Settings, GoogleApi } = state;
  return {
    FieldOffice,
    FranchiseList,
    FranchiseAdd,
    UserList,
    CloseFranchise,
    EditFieldOffice,
    UpdateFranchise,
    QuickbookLogin,
    Settings,
    GoogleApi
  }
}
const actionCreators = {
  getFieldOffice,
  getFranchiseList,
  addFieldOffice,
  getUserList,
  closeFieldOffice,
  editFieldOffice,
  updateFieldOffice,
  getUserDetail,
  getFranchise,
  getGeocodeAddress,
  resetGeocodeAddress
}
export default (connect(mapStateToProps, actionCreators)(FranchiseList));